import { useSelector } from 'react-redux';

export default function useFieldCargoOwner(fieldOwner, cargoOwner) {
  const roleRules = useSelector((state) => state.userInfo.roleIsCargoOwner);
  if (roleRules == null) return null;

  return roleRules ? cargoOwner : fieldOwner;
}
